// tslint:disable:max-line-length
import * as React from 'react';

import { Constants } from 'risesharp-common';

import { General } from './../parentClasses/general';
import { Helper } from './../utils/helper';
import withTracker from './../layout/withTracker';

class StudentPhoneInterview extends General {
  constructor(props: React.Props<any>) {
    super(props);
    this.trackContentHeight(true);
    this.displayTopLevelMessages(true);
  }

  componentDidMount() {
    this.trackContentHeight(false);
  }
  
  render() {
    return (
      <React.Fragment>
        {/* title */}
        {this.displayCustomTitleAndMeta(Constants.IDENTIFIER_STURES_PHONEINTVW)}
        <React.Fragment>
          <div className="container">
            <h3 className="my-3 pageTitle">Five Tips for a Successful Phone Interview</h3>
            <p className="my-3">
              After receiving your resume, employers that are interested in learning more about you will conduct a phone interview as the first step in the job interview process. This provides the employer with a way to quickly determine if you are a good match for the job and how you will fit into the company’s culture. You may be contacted in advance by the company to schedule the phone interview, but sometimes the call might not be scheduled in advance. You might simply receive a phone call, so you want to be prepared. 
              <br/><br/>
              Here are five tips for a successful phone interview that can help you advance to the next phase of the hiring process:
            </p>
            <p className="my-3">
              <strong>1. Answer the Phone Professionally</strong><br/>
              Always answer the phone with your first and last name and with a positive, upbeat tone. This will let the interviewer know that he or she has reached the right person and that you have a pleasant demeanor.  Because the interviewer cannot see you, you will be judged on what you say and how you express yourself. If an interviewer or recruiter unexpectedly calls you at a bad time, such as when you are in a situation where you are unable to talk, maintain your professional tone, but explain that this is not a good time for a conversation. Say something such as, "Thank you so much for contacting me. I look forward to talking with you, but I am unavailable to talk right now. Can I call you back in an hour?" 
            </p>
            <div className="my-3">
              <strong>2. Practice Interviewing</strong><br/>
              Practice answering some questions that the interviewer might ask related to your strengths and weaknesses and why you will be a good choice for the job. Some typical interview questions you may want to practice answering are:
              <br/><br/>
              <ul>
                <li>
                  How has your academic experience in college or university prepared you for this job?
                </li>
                <li>
                  What are your career goals?
                </li>
                <li>
                  How do you handle a situation where a team member is not contributing to the project?
                </li>
                <li>
                  Describe a challenge you faced in your academic work and how did you deal with it?
                </li>
                <li>
                  How do you deal with pressure?
                </li>
                <li>
                  What are your salary requirements? 
                </li>
              </ul>
              <br/>
              Using these questions and others that you think you may be asked, invite a friend or family member to do a practice with interview you. Consider recording it so you can hear how your voice sounds on the phone. Be sure that you are avoiding long pauses, or phrases, such as "uhm,"" or "uh." You’ll also be able to decide how to improve your answers after listening to the recording. 
            </div>
            <p className="my-3">
              <strong>3. Prepare for the Phone Interview</strong><br/>
                After practicing how to answer interview questions, create a few bullet points of key messages that you want to be sure to communicate. When you do the actual interview, have these printed out so that you can easily refer to them. Also, have your resume available for easy reference. In addition, have a pen and paper handy so you can jot down any important information that you think of during the interview, or important information that the interviewer tells you. Choose a place to do the interview that you are sure will be quiet and where there will be no interruptions. 
            </p>
            <div className="my-3">
              <strong>4. What to Do During the Interview</strong><br/>
              During the interview, be sure to listen to the questions. If you are not clear on a question, ask for it to be repeated. Take your time, and do not be eating anything or chewing gum. It’s fine to have a glass of water handy. Speak clearly, be articulate, and professional. Be business-like and professional to impress the interviewer. Have some questions prepared to ask the interviewer. These might include:
              <br/><br/>
              <ul>
                <li>
                  Can you describe a typical day for this job?
                </li>
                <li>
                  What are the biggest challenges of the job? 
                </li>
                <li>
                  Is there anything I have discussed that you would like me to further explain?
                </li>
              </ul>
              <br/>
              At the end of the phone call thank the interviewer, and ask what the next steps are in the process.
            </div>
            <p className="my-3">
              <strong>5. Follow-Up After the Interview</strong><br/>
              Immediately, or within a few hours after the interview, send an email thank you note. Emphasize that you are very interested in the job. If you feel you forgot to mention something during the phone call, include it in the thank you email. You can also invite the interviewer to contact you with any additional questions and that you hope to talk more with him soon.
            </p>
            <p className="my-3">
              <strong>Contact Us</strong><br/>
              We can help you get interview ready. Contact us to get started.
              <br/><br/>
              You may also want to read: <a role="button" className="buttonAsLink" onClick={() => this.props.history.push('/students/resources/re-record')}>How to Prepare for a Recorded Video Job Interview</a>.
            </p>
          </div>
        </React.Fragment>
      </React.Fragment>
    );
  }

  // display sections
  private displayCustomTitleAndMeta(identifier: string) {
    return this.getHelmetData({
      identifier,
      college_name: Helper.getCollegeName(this.props)
    });
  }
}

export default withTracker(StudentPhoneInterview);
